export default __webpack_public_path__ + "static/media/music-start.0703a397.png";